export enum FilterExternalColumnNames {
  // TODO: complete list, will have to be added to column list in SQL query
  ReceiptDateTimestamp = 'ReceiptDateTimestamp',
  LastRecordUpdatedTimestamp = 'LastRecordUpdatedTimestamp',
  LenderContactEmail = 'LenderContactEmail',
  ApprovedLenderReferenceNumber = 'ApprovedLenderReferenceNumber'
}
